<template>
  <div>
    <div v-if="params.application" class="p-3">
      <el-row type="flex" justify="space-between" align="middle" class="p-2 border rounded w-full">
        <el-col :span="20">
          <div class="flex items-center">
            <img
              :src="`https://s3.us-east-1.amazonaws.com/assets.kodefast.net/icons/connector-app/${
                getApplication().logo
              }`"
              class="h-5 w-5"
            />
            <span class="ml-1 text-sm font-medium">{{ getApplication().label }}</span>
          </div>
        </el-col>

        <el-col :span="4" class="text-right">
          <a
            href="#"
            class="text-blue-500 text-sm hover:underline whitespace-nowrap"
            @click.prevent="resetForm"
          >
            Change
          </a>
        </el-col>
      </el-row>
      <el-row>
        <el-form :model="params" :rules="rules" ref="formRef" label-position="top">
          <el-form-item prop="event" label="Event:">
            <el-select
              v-model="params.event"
              placeholder="Select Event"
              style="width: 100%"
              filterable
              clearable
              @change="handleChange"
            >
              <el-option
                v-for="(event, index) in getApplication().events"
                :key="index"
                :label="event.eventName"
                :value="event.eventKey"
              />
            </el-select>
          </el-form-item>

          <el-form-item prop="integration" label="Integration:">
            <el-select
              v-model="params.integration"
              placeholder="Select Integration"
              style="width: 100%"
            >
              <el-option
                v-for="(integration, index) in integrations"
                :key="index"
                :label="integration.name"
                :value="integration._id"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="entity_filters" label="Entity Filters:" v-if="params.exportable">
            <el-select v-model="params.filter" placeholder="Select Filter" style="width: 100%">
              <el-option
                v-for="(currentFilter, index) in entityAllFilters"
                :key="index"
                :label="currentFilter.filter_name"
                :value="currentFilter._id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-for="(field, index) in dynamicFieldsInputs"
            :key="index"
            :label="field.label"
            :prop="`form.${field.key}`"
          >
            <component :is="getFieldComponent(field.type)" v-model="params.form[field.key]" />
          </el-form-item>
          <br />
          <el-button v-if="hideConfigButton" @click="openSourceConfiguration(step)">
            <i style="color: #409eff" class="el-icon-setting">configure Mapping</i>
          </el-button>

          <el-button v-else @click="closeSourceConfig" type="primary">save</el-button>
        </el-form>
      </el-row>
    </div>

    <div v-else class="p-3">
      <div>
        <el-input
          placeholder="Search Source"
          prefix-icon="el-icon-search"
          class="search"
          size="small"
          v-model="searchApplication"
          clearable
        />
      </div>
      <div class="px-4 pb-4">
        <el-collapse @change="handleSource">
          <el-collapse-item v-for="(item, index) in filteredApps" :key="index" :name="item.key">
            <template #title>
              <img
                :src="`https://s3.us-east-1.amazonaws.com/assets.kodefast.net/icons/connector-app/${item.logo}`"
                alt="Logo"
                style="height: 20px; vertical-align: middle; margin-right: 6px"
              />
              {{ item.label }}
            </template>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        filteredApplications: [],
        dynamicFieldsInputs: [],
        searchApplication: '',
        rules: {
          event: [
            {
              required: true,
              message: 'Please select an event',
              trigger: 'change',
            },
          ],
          integration: [
            {
              required: true,
              message: 'Please select an integration',
              trigger: 'change',
            },
          ],
        },
      };
    },
    props: {
      applications: Array,
      params: Object,
      integrations: Array,
      entityAllFilters: Array,
    },
    computed: {
      filteredApps() {
        const query = this.searchApplication.toLowerCase();
        if (!query) {
          return this.applications;
        }
        return this.applications.filter((app) => app.label.toLowerCase().includes(query));
      },
      hideConfigButton() {
        let application = this.getApplication();
        let event = application?.events.find((event) => event.eventKey === this.params.event);
        if (
          event &&
          event.settings &&
          (event.settings.dynamicResponseFields || event.settings.availableColumns.length)
        ) {
          return true;
        } else {
          return false;
        }
      },
    },
    watch: {
      'params.event': {
        immediate: true,
        handler() {
          this.dynamicFieldsInputs = this.getMergedItems();
        },
      },
    },
    methods: {
      getFieldComponent(type) {
        switch (type) {
          case 'text':
            return 'el-input';
          case 'textarea':
            return 'el-input';
          case 'number':
            return 'el-input-number';
          case 'select':
            return 'el-select';
          case 'checkbox':
            return 'el-checkbox';
          case 'date':
            return 'el-date-picker';
          default:
            return 'el-input';
        }
      },
      handleChange(value) {
        let application = this.getApplication();
        let event = application?.events.find((event) => event.eventKey === value);
        this.params['importable'] = event?.settings?.importable;
        this.params['exportable'] = event?.settings?.exportable;
      },
      getMergedItems() {
        let fields = [];
        if (this.params.application && this.params.event) {
          let application = this.getApplication();
          let event = application.events.find((event) => event.eventKey === this.params.event);
          fields = event.settings.requiredFields || [];
        } else {
          fields = [];
        }
        const dynamicRules = {};
        const rules = [];
        fields.forEach((field) => {
          if (field.isRequired) {
            rules.push({
              required: true,
              message: `Please enter ${field.label}`,
              trigger: field.type === 'select' ? 'change' : 'blur',
            });
          }
          dynamicRules[`form.${field.key}`] = rules;
        });
        this.rules = { ...this.rules, ...dynamicRules };
        return fields;
      },
      getApplication() {
        return this.applications.find((app) => app.key === this.params.application);
      },
      handleSource(value) {
        this.$set(this.params, 'application', value[0]);
      },
      openSourceConfiguration() {
        this.$refs.formRef.validate(async (valid) => {
          try {
            if (valid) {
              let application = this.getApplication();
              this.$emit('openMapping', application);
            } else {
              console.warn('Validation failed');
            }
          } catch (err) {
            console.log('err', err);
          }
        });
      },
      closeSourceConfig() {
        this.$emit('closeSourcesList');
      },
      resetForm() {
        this.$set(this.params, 'application', '');
        this.$set(this.params, 'integration', '');
        this.$set(this.params, 'event', '');
        this.$set(this.params, 'form', {});
        this.$set(this.params, 'mappingConfig', {});
      },
    },
  };
</script>
